import { render, staticRenderFns } from "./_base-homepage-categories-tabs.vue?vue&type=template&id=49fe85af"
import script from "./_base-homepage-categories-tabs.vue?vue&type=script&lang=js"
export * from "./_base-homepage-categories-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports